var _yup$object;
import * as yup from "yup";
import { NAME, EMAIL, MESSAGE } from "./field-names";
import { INVALID_EMAIL_MESSAGE, REQUIRED_MESSAGE } from "../validation-messages";
export var validationSchema = yup.object((_yup$object = {}, _yup$object[NAME] = yup.string().required(REQUIRED_MESSAGE), _yup$object[EMAIL] = yup.string().required(REQUIRED_MESSAGE).email(INVALID_EMAIL_MESSAGE), _yup$object[MESSAGE] = yup.string().required(REQUIRED_MESSAGE), _yup$object));
